<template>
  <div>

    <div class="xes-1v1-auth-result">

      <img class="xes-1v1-auth-result-icon" :src="getTipImg" alt="" />

      <br>

      <p class="xes-1v1-auth-result-content">
        {{ succFlag === 'true' ? '授权成功' : '授权失败' }}
      </p>
      <div class="xes-1v1-auth-result-des">
        <span class="xes-1v1-auth-result-des-pre" v-show="succFlag === 'true'">账户</span>
        <span class="xes-1v1-auth-result-des-name" v-show="succFlag === 'true'">{{ userName }}</span>
        <span class="xes-1v1-auth-result-des-txt">{{ succFlag === 'true' ? this.succDes : getFailDes }}
        </span>
      </div>
    </div>
    <div class="xes-1v1-auth-result-next">
      <button class="xes-1v1-auth-result-btn" v-if="isShowBtn === 'true'"  @click="authEnd">
        我知道了
      </button>
    </div>
  </div>
</template>

<script>
import appUtil from "@/utils/appUtil";
export default {
  data() {
    return {
      resultTips: "",
      // succTips:"您在学而思APP的账户已经超过上限，无法绑定新的账户，请释放学而思APP的某个账户后，重新授权，或者联系您的1对1老师处理，谢谢！",
      failTips: this.$route.query.tips,
      succFlag: this.$route.query.succFlag,
      succDes: "授权成功,后续您可以使用当前用户的手机号登录学而思app，继续您的学而思之旅",
      failDes: "您在学而思app的账号已经超出上限，无法绑定新的账号，请释放学而思app的某个账号后，重新授权，或者联系您的1对1老师处理，谢谢！",
      userName: this.$route.query.userName,
      code: this.$route.query.code,
      isShowBtn: false
    }
  },
  created() {
    this.isShowBtn =  localStorage.getItem("isShowBtn")
    console.log("lsj", this.isShowBtn)
  },
  computed: {
    getTipImg() {
      return this.succFlag === 'true' ? require('@/assets/img/login/auth_success.png') : require('@/assets/img/login/auth_fail.png')
    },

    getFailDes() {
        return ( this.code === '600011' ||  this.code === '999999' )? '无法绑定新的账号，请联系您的1对1老师处理，感谢':this.failDes
    }
  },
  methods: {

    authEnd() {

      let util = new appUtil()
      let isApp = util.isApp()
      if (isApp === "android" || isApp === "ios") {
        window.dhsdk.finishInterface({
          success: () => {
            console.log("关闭页面")
          },
          fail: () => {
          },
        });
      }else {
        // /auth
        this.$router.push({
          path: "/auth",
        });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.xes-1v1-auth-result {
  margin: 32px 36px 0 34px;

  .xes-1v1-auth-result-icon {
    position: relative;
    width: 60px;
    height: 60px;
    left: 50%;
    transform: translateX(-50%);

  }

  .xes-1v1-auth-result-content {
    text-align: center;
    margin-top: 16px;
    font-weight: 600;
    font-size: 22px;
    color: #222;

  }


  .xes-1v1-auth-result-des {
    margin-top: 32px;
    &-pre {
      color: #5D646E;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }

    &-txt {
      color: #5D646E;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }

    &-name {
      color: #222;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
    }
  }
}

.xes-1v1-auth-result-next {
  position: fixed;
  bottom: 50px;
  left: 20px;
  right: 20px;

  .xes-1v1-auth-result-btn {
    font-size: 16px;
    border-radius: 24px;
    background-color: #E02727;
    color: white;
    font-weight: 500;
    height: 44px;
    width: 100%;
  }
}
</style>